import FlashMessage from './flash-messages';
const flashMessage = new FlashMessage(3);

const mFormat = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUR',
    minimumFractionDigits: 2
});

const rur = (val) => {
    return mFormat.format(val).replace("RUR", "");
};

let qtyChanged = false;

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e);
    }
}

function productFiltersHandler() {

    const elProduct = document.getElementById('product-details');
    const elFilters = document.getElementsByClassName('sub-product-selector');

    if (elFilters.length > 0) {
        Array.from(elFilters).forEach(function(el) {
            el.addEventListener('change', function () {
                let filterParams = '';
                let prefix = '-and-';
                Array.from(elFilters).forEach(function(el) {
                    filterParams += el.value.length > 0? `${prefix}${el.id}-is-${el.value}` : '';
                });

                filterParams = filterParams.substring(5);

                window.location.replace(elProduct.dataset.url + (filterParams.length > 7? '/filter/' + filterParams : '') + '#sub-products-filters')
            })
        })
    }

}

function productShopCart() {
    const elBuy = document.getElementById('add-to-cart');
    const elProduct = document.querySelector('.product-cart');
    if (elBuy) {
        // Change QTY
        document.getElementById('shop-cart-qty').addEventListener('change', function () {
            elProduct.dataset.qty = this.value;
            const price = elProduct.dataset.price;
            if (price > 0) {
                elProduct.querySelector('.product-cart__price-value').innerHTML = formatMoney(elProduct.dataset.price * this.value);
            }
        });

        // Add to Cart
        elBuy.addEventListener('click', function () {
            addToCart(elProduct.dataset.id, elProduct.dataset.title, elProduct.dataset.qty);
        });
    }
}


function productMiniShopCart() {
    const elButtons = document.getElementsByClassName('mini-shop-cart-button');
    if (elButtons.length > 0) {
        Array.from(elButtons).forEach(function(el) {
            el.addEventListener('click', function () {

                const elParent = this.parentElement.parentElement;
                const body = document.querySelector("body");
                const template = document.querySelector('#shop-mini-box-template');
                const clone = template.content.cloneNode(true);
                let elMinBox = clone.querySelector('#shop-mini-box');

                elMinBox.dataset.id = elParent.dataset.id;
                elMinBox.dataset.title = elParent.dataset.title;
                elMinBox.dataset.qty = 1;

                elMinBox.querySelector('.shop-mini-title').innerHTML = elParent.dataset.title;

                elMinBox.dataset.price = elParent.dataset.price;
                elMinBox.querySelector('.shop-mini-title').innerHTML = elParent.dataset.title;

                const price = parseFloat(elParent.dataset.price);
                elMinBox.querySelector('.shop-mini-price-value').innerHTML = formatMoney(price);

                if (price === 0) {
                    elMinBox.querySelector('.shop-mini-price').style.display = "none";
                }


                body.appendChild(clone);

                // Close Event
                document.getElementById('shop-mini-close').addEventListener('click', function () {
                    this.parentElement.remove();
                })

                // Change QTY Event
                document.getElementById('shop-mini-input').addEventListener('change', function () {
                    if (parseInt(this.value) < 1) {
                        this.value = 1;
                    }
                    elMinBox.dataset.qty = this.value;
                    elMinBox.querySelector('.shop-mini-price-value').innerHTML = formatMoney(elMinBox.dataset.price * this.value);
                })

                // Add To Cart Event
                document.getElementById('add-mini-cart').addEventListener('click', function () {
                    addToCart(elMinBox.dataset.id, elMinBox.dataset.title, elMinBox.dataset.qty);
                })
            })
        })
    }
}

function addToCart(id, title, qty) {

        const elProduct = document.getElementById('product-details');

        let params = {
            product_id: id,
            product_qty: qty,
        };

        axios({
            method: 'post',
            url: elProduct.dataset.action,
            data: params,
        })
        .then(function (response) {
            flashMessage.add(`Добавлено в корзину:<br/><strong>${response.data.title} (${params.product_qty} шт.)</strong>`, 'cart');
            const elCartCounter = document.querySelector('.top-line-cart-counter');
            elCartCounter.classList.remove('hidden');
            elCartCounter.innerHTML = response.data.rowCount;
            document.getElementById('shop-mini-box').remove();
        })
        .catch(function (response) {
            console.log(response);
        })
}


function productListCart() {
    // ---------------------------------- Shop Cart Delete
    const elDeleteButtons = document.getElementsByClassName('shop-cart__delete-button');
    if (elDeleteButtons.length > 0) {
        Array.from(elDeleteButtons).forEach(function(el) {
            el.addEventListener('click', function () {
                const elItem = document.getElementById(this.dataset.item);
                elItem.classList.toggle('deleted');
                updatePrices();
            })
        })
    }

    // ---------------------------------- Shop Cart Inputs
    const elQtyInputs = document.getElementsByClassName('shop-cart__qty-input');
    if (elQtyInputs.length > 0) {
        Array.from(elQtyInputs).forEach(function(elQtyInput) {
            elQtyInput.addEventListener('change', function () {
                qtyChanged = true;
                updatePrices();
            })
        })
    }

    // ---------------------------------- Shop Cart Inputs MINUS Button
    const elMinusQty = document.getElementsByClassName('left-qty-button');
    if (elMinusQty.length > 0) {
        Array.from(elMinusQty).forEach(function(el) {
            el.addEventListener('click', function () {
                let Qty = this.parentElement.querySelector('.shop-cart__qty-input');
                if (parseInt(Qty.value) > 1) {
                    Qty.value = parseInt(Qty.value) - 1;
                    qtyChanged = true;
                    updatePrices();
                }
            })
        })
    }

    // ---------------------------------- Shop Cart Inputs PLUS Button
    const elPlusQty = document.getElementsByClassName('right-qty-button');
    if (elPlusQty.length > 0) {
        Array.from(elPlusQty).forEach(function(el) {
            el.addEventListener('click', function () {
                let Qty = this.parentElement.querySelector('.shop-cart__qty-input');
                Qty.value = parseInt(Qty.value) + 1;
                qtyChanged = true;
                updatePrices();
            })
        })
    }

}

// Update prices and buttons for the Shop Cart Page
function updatePrices() {
    const elQtyInputs = document.getElementsByClassName('shop-cart__qty-input');
    if (elQtyInputs.length > 0) {
        let sum = 0;
        Array.from(elQtyInputs).forEach(function(elQtyInput) {
            const item = elQtyInput.parentElement.parentElement.parentElement.parentElement;
            const priceText = elQtyInput.parentElement.parentElement.parentElement.querySelector('.shop-cart__price-text');
            const priceItem = elQtyInput.value * parseFloat(elQtyInput.dataset.price);
            const elDeleted = item.querySelector('input[name="deleted[]"]');

            if (!item.classList.contains('deleted')) {
                sum = sum + priceItem;
                if (priceItem > 0) {
                    priceText.innerHTML = rur(priceItem);
                }
                elDeleted.value = false;
            } else {
                elDeleted.value = true;
            }
        });

        const elTotal = document.querySelector('.shop-cart__total-text');
        elTotal.innerHTML = rur(parseFloat(sum).toFixed(2));

        const price = document.querySelector('.shop-cart__total').dataset.price;
        const elUpdateButton = document.querySelector('.update-shop-cart');
        const elCheckout = document.querySelector('.process-order');
        const elsRemoved = document.querySelectorAll('.shop-cart__list .deleted');

        if (parseFloat(elTotal.innerHTML) === parseFloat(price) && elsRemoved.length === 0 && !qtyChanged) {
            elUpdateButton.classList.add('hidden');
            elCheckout.classList.remove('hidden');
        } else {
            elUpdateButton.classList.remove('hidden');
            elCheckout.classList.add('hidden');
        }
    }
}


export default {productFiltersHandler, productShopCart, productMiniShopCart, productListCart};
